import React, {useState, useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import * as vars from './../vars.js';

const Q = vars.starlinkQuote;

// Great-circle distance in km.
function haversineKm(a, b) {
  const toRad = (d) => d * Math.PI / 180;
  const R = 6371;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Driving distance via Google Routes API. Resolves null when the API is not
// enabled on the key (or any other failure) so the caller can fall back.
async function routeKm(from) {
  try {
    const res = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': Q.googleKey,
        'X-Goog-FieldMask': 'routes.distanceMeters',
      },
      body: JSON.stringify({
        origin: { location: { latLng: { latitude: from.lat, longitude: from.lng } } },
        destination: { location: { latLng: { latitude: Q.ref.lat, longitude: Q.ref.lng } } },
        travelMode: 'DRIVE',
      }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    const m = data && data.routes && data.routes[0] && data.routes[0].distanceMeters;
    return Number.isFinite(m) ? m / 1000 : null;
  } catch (_) {
    return null;
  }
}

async function geocode(address) {
  const hasProvince = /saskatchewan|\bsk\b|canada/i.test(address);
  const q = hasProvince ? address : address + ', Saskatchewan, Canada';
  const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(q)
    + '&region=ca&components=country:CA&key=' + Q.googleKey;
  const res = await fetch(url);
  const data = await res.json();
  if (data.status !== 'OK' || !data.results || !data.results.length) return null;
  const r = data.results[0];
  return { lat: r.geometry.location.lat, lng: r.geometry.location.lng, label: r.formatted_address };
}

function bandFor(km) {
  return Q.bands.find((b) => km <= b.maxKm) || null;
}

var parseOnce=false;
function Starlink(props) {

  const [errMessage, setErrMessage] = useState("");
  const [existingObj, setExistingObj] = useState(false);

  useEffect(() => {
    if(!parseOnce) {
      const queryParams = new URLSearchParams(window.location.search);
      const message = queryParams.get('message');
      const obj = queryParams.get('obj');
      setErrMessage(message);
      setExistingObj(JSON.parse(obj));
      if(existingObj) {
        parseOnce=true;
      }
    }
  });

  const [shiftImage1Style, setShiftImage1Style] = useState({backgroundPosition: 'right -10px'});

  window.addEventListener("scroll", (event) => {
    if(window !== undefined) {
      let scroll = window.scrollY;
      setShiftImage1Style({backgroundPosition: 'right '+(-scroll*0.075-10)+'px'});
    }
  });

  // ---- location-based quote ----
  const [address, setAddress] = useState('');
  const [busy, setBusy] = useState(false);
  const [quoteError, setQuoteError] = useState('');
  const [quote, setQuote] = useState(null); // { label, km, method, band }

  async function quoteForPoint(point, label) {
    const road = await routeKm(point);
    const km = road !== null ? road : haversineKm(point, Q.ref) * Q.roadFactor;
    const rounded = Math.round(km);
    setQuote({ label, km: rounded, method: road !== null ? 'road' : 'estimate', band: bandFor(rounded) });
  }

  async function onGetPrice(e) {
    if (e) e.preventDefault();
    const a = address.trim();
    if (!a) { setQuoteError('Type a town or address first.'); return; }
    setBusy(true); setQuoteError(''); setQuote(null);
    try {
      const g = await geocode(a);
      if (!g) { setQuoteError("We couldn't find that location. Try adding the town name or a nearby community."); }
      else { await quoteForPoint({ lat: g.lat, lng: g.lng }, g.label); }
    } catch (_) {
      setQuoteError('Something went wrong looking that up. Text us your location instead and we’ll quote you.');
    } finally { setBusy(false); }
  }

  function onUseMyLocation() {
    if (!navigator.geolocation) { setQuoteError('Your browser can’t share a location. Type your town instead.'); return; }
    setBusy(true); setQuoteError(''); setQuote(null);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try { await quoteForPoint({ lat: pos.coords.latitude, lng: pos.coords.longitude }, 'your current location'); }
        finally { setBusy(false); }
      },
      () => { setBusy(false); setQuoteError('Location access was blocked. Type your town instead.'); },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  }

  const resultBox = { maxWidth: '760px', padding: '24px', marginTop: '16px', background: 'rgba(0,0,0,0.05)', borderRadius: '8px' };

  return (
    <div className="page">
      <div style={{display: !errMessage? 'block':'none'}}>
      <div className="image2" style={shiftImage1Style}>
        <h1>Starlink Installations</h1>
        <div className="left_text_box">
        <h4><span className="brand_color_text"><i>Skip the ladder.</i></span></h4><br/><br/>
        <p>If you haven't already visit <a className="white_link" href="https://starlink.com"><b>starlink.com</b></a>, enter your location, and order the service.</p>
        <p>You'll receive a Starlink dish in the mail. Plenty of people install it themselves. If you'd rather not be on a tin roof in November, that's where we come in.</p>
        <p>If you'd like the help of our technicians and equipment, <br/>Last Mountain Wireless offers <i><span className="brand_color_text"><b>professional installations starting at $500</b></span>, travel included &mdash; enter your location below for your exact price.</i></p>
        </div><br/><br/>
        <Button href="tel://13069004321" variant="primary" size="lg" active>Text or Call 1.306.900.4321</Button>
      </div>

      <div className="text_block_white" id="pricing">
        <h3>Your Installation Price</h3>
        <p>Our price depends on how far we drive. Tell us where the dish is going and we'll give you the number &mdash; travel included.</p>
        <Form onSubmit={onGetPrice} style={{maxWidth: '760px'}}>
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
            <Form.Control
              type="text"
              className="light text"
              placeholder="Town or address (e.g. Nokomis, SK)"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              style={{flex: '1 1 260px', minWidth: '200px'}}
              aria-label="Town or address"
            />
            <Button type="submit" variant="primary" disabled={busy}>{busy ? 'Working…' : 'Get my price'}</Button>
            <Button type="button" variant="outline-dark" disabled={busy} onClick={onUseMyLocation}>Use my location</Button>
          </div>
        </Form>
        {quoteError && <p style={{color: '#b00020', marginTop: '12px'}}>{quoteError}</p>}
        {quote && quote.band && (
          <div style={resultBox}>
            <p style={{marginBottom: '6px'}}>About <b>{quote.km} km</b> from {Q.ref.name} by road{quote.method === 'estimate' ? ' (estimated)' : ''} &mdash; {quote.label}</p>
            <h4 style={{marginTop: '12px'}}>Standard installation: <span className="brand_dark_color_text">${quote.band.standard}</span></h4>
            <h5>With bucket truck: <span className="brand_dark_color_text">${quote.band.bucket}</span></h5>
            <p style={{marginTop: '12px', marginBottom: '16px'}}>Travel included, plus applicable taxes. Mounting hardware is extra and quoted before your booking. A bucket truck is needed for high, steep or slippery roofs and antenna towers &mdash; we'll tell you which applies when we book.</p>
            <Button href="tel://13069004321" variant="primary" size="lg" active>Text or Call 1.306.900.4321</Button>
          </div>
        )}
        {quote && !quote.band && (
          <div style={resultBox}>
            <p style={{marginBottom: '6px'}}>About <b>{quote.km} km</b> from {Q.ref.name} by road{quote.method === 'estimate' ? ' (estimated)' : ''} &mdash; {quote.label}</p>
            <h4 style={{marginTop: '12px'}}>That's outside our installation range.</h4>
            <p style={{marginBottom: 0}}>We book Starlink installations within {Q.maxKm} km of {Q.ref.name} and aren't able to make the trip beyond that. Sorry we can't help this time.</p>
          </div>
        )}
      </div>

      <div className="text_block_white" id="learn_more">
        <h3>A Clear View of the Sky</h3>
        <p>We'll help you determine the best position for your Starlink dish on your property (typically on the roof of your home). You will have fewer disconnects and higher speeds with an unobstructed view of the sky.</p>
        <h3>A Variety of Mounting Hardware</h3>
        <p>We utilize a variety of mounting hardware for your dish including tripods, j-mounts, telescoping poles, non-penetrating roof mounts and antenna towers.</p>
        <h3>Bucket Truck</h3>
        <p>Some installs need the bucket truck: high or steep roofs, slippery tin, antenna towers. It's the second price in your quote above &mdash; we'll tell you when we book.</p>
        <h3>Up On the Roof</h3>
        <p>If possible we will avoid penetrating your roof entirely, but if we're not able to, we will minimize the number of holes we create and we'll properly caulk, seal and/or tar them.</p>
        <h3>Fit, Finish and Seal</h3>
        <p>We usually have to drill a single hole through an exterior wall in order to bring the Starlink wire into your home. If possible we will use a marine grade exterior cover in order to seal that hole from the elements (included at no charge), and if we end up in a finished room on the inside we will offer to use an interior faceplate as well.</p>
        <br/>
        <h5><i>*Please Note</i></h5>
        <p>We do not supply or finance the Starlink hardware. You must purchase the Starlink hardware and subscribe to the service through <a href="https://starlink.com"><b>starlink.com</b></a>.</p>
      </div>
      </div>
    </div>);

}

export default Starlink;
